import React from 'react'
import Main from './components/Main.js'

function App() {
  return (   
    <Main />
  );
}

export default App
